import React from 'react'
import { Outlet, NavLink } from 'react-router-dom'
import MyIcon from '../../components/general/icon'

export default function MoreNav() {
  const merchantOid = localStorage.getItem('merchant_oid')

  const computedClassName = ({ isActive }) => {
    return isActive ?  "secondaryNav-menu secondaryNav-menuActive" : "secondaryNav-menu"
  }

  return (
    <div className="secondaryNav-page">
      <div className="secondaryNav-container">
        <div className="secondaryNav-headline">更多应用</div>

          <div className="secondaryNav-box">
            <div className="secondaryNav-title">人才招聘</div>
            <NavLink to="job_unit" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='gongsi' /></div>
              <div className="secondaryNav-name">招聘单位</div>
            </NavLink>
            <NavLink to="job_category" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='lanmu' /></div>
              <div className="secondaryNav-name">职位分类</div>
            </NavLink>
            <NavLink to="job_post" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='gangwei' /></div>
              <div className="secondaryNav-name">招聘职位</div>
            </NavLink>
            <NavLink to="job_application" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='toudi' /></div>
              <div className="secondaryNav-name">投递记录</div>
            </NavLink>
            <NavLink to="job_resume" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='jianli' /></div>
              <div className="secondaryNav-name">用户简历</div>
            </NavLink>
          </div>

          {['200643-1716434092-565569', '530022-1717135827-326696'].includes(merchantOid) && (
            <div className="secondaryNav-box">
              <div className="secondaryNav-title">新生入学资格</div>
              <NavLink to="freshmen_deferral" className={computedClassName}>
                <div className="secondaryNav-icon"><MyIcon name='yanqi' /></div>
                <div className="secondaryNav-name">保留申请</div>
              </NavLink>
              <NavLink to="freshmen_readmission" className={computedClassName}>
                <div className="secondaryNav-icon"><MyIcon name='fuxue' /></div>
                <div className="secondaryNav-name">复学申请</div>
              </NavLink>
              <NavLink to="freshmen_config" className={computedClassName}>
                <div className="secondaryNav-icon"><MyIcon name='peizhixinxi' /></div>
                <div className="secondaryNav-name">配置信息</div>
              </NavLink>
            </div>
          )}

          <div className="secondaryNav-box">
            <div className="secondaryNav-title">就业服务</div>
            <NavLink to="enterprise_entry" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='ruku' /></div>
              <div className="secondaryNav-name">企业入驻申请</div>
            </NavLink>
          </div>

          <div className="secondaryNav-box">
            <div className="secondaryNav-title">生涯测评</div>
            <NavLink to="assessment_record" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='jiance' /></div>
              <div className="secondaryNav-name">测评记录</div>
            </NavLink>
            <NavLink to="assessment_config" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='peizhixinxi' /></div>
              <div className="secondaryNav-name">配置信息</div>
            </NavLink>
          </div>
      </div>
      <Outlet />
    </div>
  )
}
